import { Skeleton } from "antd";

function NotificationCardSkeleton() {
  return (
    <div className="px-4 py-2.5 flex flex-col gap-1 border-b last:border-b-0 border-gray-200 dark:border-gray-700">
      <div className="flex items-center justify-between">
        <Skeleton.Node className="!h-4 !w-40 dark:bg-[#1f2937] rounded-sm" />
        <Skeleton.Node className="!h-4 !w-20 dark:bg-[#1f2937] rounded-sm" />
      </div>
      <Skeleton.Node className="!h-4 !w-full dark:bg-[#1f2937] rounded-sm" />
    </div>
  );
}
export default NotificationCardSkeleton;
